"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationHandler = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const ErrorIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ErrorIcon"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const WarningIcon_1 = __importDefault(require("@opsbase/web-icons/icons/WarningIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const NotificationType_1 = __importDefault(require("../NotificationType"));
const useNotification_1 = __importDefault(require("../useNotification"));
const useNotificationActions_1 = __importDefault(require("../useNotificationActions"));
const makeMyClasses = () => ({
    root: {
        '& .MuiSnackbarContent-message': {
            width: '100%',
        },
    },
    okcancel: {
        color: lib_palette_1.default.error.main,
        backgroundColor: lib_palette_1.default.White.main,
    },
    success: {
        backgroundColor: lib_palette_1.default.positive.main,
    },
    error: {
        backgroundColor: lib_palette_1.default.error.main,
    },
    info: {
        backgroundColor: lib_palette_1.default.secondary.main,
    },
    warning: {
        backgroundColor: lib_palette_1.default.warning.main,
    },
    icon: {
        fontSize: 16,
        margin: 4,
    },
});
function NotificationHandler() {
    const [current, setCurrent] = (0, react_1.useState)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const notification = (0, useNotification_1.default)();
    const { clearNotifications } = (0, useNotificationActions_1.default)();
    const handleClose = (0, react_1.useCallback)(() => {
        var _a;
        (_a = current === null || current === void 0 ? void 0 : current.onCancel) === null || _a === void 0 ? void 0 : _a.call(current);
        setCurrent(undefined);
    }, [current]);
    const handleOk = (0, react_1.useCallback)(() => {
        var _a;
        (_a = current === null || current === void 0 ? void 0 : current.onOk) === null || _a === void 0 ? void 0 : _a.call(current);
        setCurrent(undefined);
    }, [current]);
    (0, react_1.useEffect)(() => {
        if (notification) {
            clearNotifications();
            setCurrent(notification);
        }
    }, [clearNotifications, notification]);
    const className = {
        [NotificationType_1.default.OK_CANCEL]: myCss.okcancel,
        [NotificationType_1.default.ERROR]: myCss.error,
        [NotificationType_1.default.WARNING]: myCss.warning,
        [NotificationType_1.default.INFO]: myCss.info,
        [NotificationType_1.default.SUCCESS]: myCss.success,
    }[(current === null || current === void 0 ? void 0 : current.level) || NotificationType_1.default.ERROR];
    const Icon = {
        [NotificationType_1.default.OK_CANCEL]: WarningIcon_1.default,
        [NotificationType_1.default.ERROR]: ErrorIcon_1.default,
        [NotificationType_1.default.WARNING]: WarningIcon_1.default,
        [NotificationType_1.default.INFO]: InfoIcon_1.default,
        [NotificationType_1.default.SUCCESS]: CheckIcon_1.default,
    }[(current === null || current === void 0 ? void 0 : current.level) || NotificationType_1.default.ERROR];
    const autoHideDuration = {
        [NotificationType_1.default.OK_CANCEL]: undefined,
        [NotificationType_1.default.ERROR]: 5000,
        [NotificationType_1.default.WARNING]: 4000,
        [NotificationType_1.default.INFO]: 3000,
        [NotificationType_1.default.SUCCESS]: 3000,
    }[(current === null || current === void 0 ? void 0 : current.level) || NotificationType_1.default.ERROR];
    const buttons = (0, react_1.useMemo)(() => {
        if (!current)
            return null;
        if (current.level === NotificationType_1.default.OK_CANCEL) {
            return (react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(Button_1.default, { small: true, color: current.cancelColor || lib_palette_1.default.White, label: current.cancelLabel || lib_i18n_1.default.t('cancel'), onClick: handleClose }),
                react_1.default.createElement(Button_1.default, { small: true, color: current.okColor || lib_palette_1.default.White, label: current.okLabel || lib_i18n_1.default.t('ok'), onClick: handleOk })));
        }
        return (react_1.default.createElement(Button_1.default, { small: true, color: lib_palette_1.default.White, label: current.okLabel || lib_i18n_1.default.t('ok'), onClick: handleClose }));
    }, [current, handleClose, handleOk]);
    const message = (0, react_1.useMemo)(() => {
        if (!current)
            return null;
        if (current.level === NotificationType_1.default.OK_CANCEL) {
            return (react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true },
                react_1.default.createElement(Horizontal_1.default, { stretch: true, centered: true, gutter: true },
                    react_1.default.createElement(Icon, { className: myCss.icon }),
                    react_1.default.createElement(Pane_1.default, { grow: true }, current === null || current === void 0 ? void 0 : current.message)),
                buttons));
        }
        return (react_1.default.createElement(Horizontal_1.default, { stretch: true, centered: true, gutter: true },
            react_1.default.createElement(Icon, { className: myCss.icon }),
            react_1.default.createElement(Pane_1.default, { grow: true }, current === null || current === void 0 ? void 0 : current.message),
            buttons));
    }, [Icon, buttons, current, myCss === null || myCss === void 0 ? void 0 : myCss.icon]);
    if (!current)
        return null;
    return (react_1.default.createElement(core_1.Snackbar, { className: myCss.root, anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, open: !!current, onClose: handleClose, autoHideDuration: autoHideDuration },
        react_1.default.createElement(core_1.SnackbarContent, { style: { width: '100%' }, className: className, message: message })));
}
exports.NotificationHandler = NotificationHandler;
exports.default = NotificationHandler;
